const IVORY = "#F8F4EC";
const GOLD = "#C9A15C";
const DENIM = "#6E8FB8";
const CUIR = "#8A5A3B";

const s = { fill: "none", stroke: IVORY, strokeWidth: 2.2, strokeLinecap: "round", strokeLinejoin: "round" };
const g = { ...s, stroke: GOLD, strokeWidth: 1.6 };
const d = { ...s, stroke: DENIM };

const visuals = {
  massage: (
    <g>
      <path {...s} d="M55 120 Q45 80 75 65 Q105 52 118 78 Q128 100 108 118 Q82 138 55 120 Z" />
      <path {...g} d="M70 95 Q85 82 102 92" />
      <circle {...s} cx="150" cy="70" r="16" />
      <circle {...s} cx="150" cy="130" r="16" />
      <line {...s} x1="150" y1="86" x2="150" y2="114" />
      <path {...s} d="M52 160 Q60 140 80 142 Q96 144 94 162 Q92 178 72 178 Q54 177 52 160 Z" />
      <line {...g} x1="74" y1="178" x2="74" y2="192" />
    </g>
  ),
  masque: (
    <g>
      <path {...s} d="M45 75 Q45 45 100 45 Q155 45 155 75 L150 125 Q146 155 100 155 Q54 155 50 125 Z" />
      <ellipse {...s} cx="78" cy="95" rx="14" ry="8" />
      <ellipse {...s} cx="122" cy="95" rx="14" ry="8" />
      <path {...s} d="M92 125 Q100 130 108 125" />
      {[60, 78, 96, 114, 132].map((x) => (
        <circle key={x} fill={GOLD} cx={x} cy="65" r="2.4" />
      ))}
      {[70, 100, 130].map((x) => (
        <circle key={x} fill={GOLD} opacity="0.6" cx={x} cy="140" r="2" />
      ))}
    </g>
  ),
  gourdeAdulte: (
    <g>
      <rect {...s} x="82" y="58" width="36" height="118" rx="16" />
      <rect {...s} x="88" y="40" width="24" height="18" rx="6" />
      <line {...d} x1="82" y1="120" x2="118" y2="120" />
      <line {...d} x1="82" y1="128" x2="118" y2="128" />
      <line {...g} x1="100" y1="70" x2="100" y2="108" />
    </g>
  ),
  gourdeEnfant: (
    <g>
      <rect {...s} x="76" y="84" width="48" height="84" rx="20" />
      <path {...s} d="M88 84 Q88 62 100 62 Q112 62 112 84" />
      <circle {...d} cx="100" cy="120" r="12" />
      <line {...g} x1="76" y1="152" x2="124" y2="152" />
    </g>
  ),
  sacQuotidien: (
    <g>
      <path {...d} d="M55 90 L145 90 L152 165 Q153 174 144 174 L56 174 Q47 174 48 165 Z" />
      <path {...s} d="M78 90 Q78 58 100 58 Q122 58 122 90" />
      <line stroke={CUIR} strokeWidth="4" strokeLinecap="round" fill="none" d="M80 90 Q80 62 100 62 Q120 62 120 90" />
      <line {...g} strokeDasharray="4 6" x1="60" y1="104" x2="140" y2="104" />
    </g>
  ),
  sacVoyage: (
    <g>
      <rect {...d} x="42" y="92" width="116" height="66" rx="22" />
      <path {...s} d="M82 92 Q82 68 100 68 Q118 68 118 92" />
      <line stroke={CUIR} strokeWidth="4" strokeLinecap="round" fill="none" d="M84 92 Q84 72 100 72 Q116 72 116 92" />
      <line {...g} strokeDasharray="5 6" x1="42" y1="112" x2="158" y2="112" />
      <circle {...g} cx="100" cy="112" r="3" />
    </g>
  ),
};

export default function ProductVisual({ variant, className = "" }) {
  return (
    <svg viewBox="0 0 200 200" className={className} role="img" aria-label={`Illustration ${variant}`}>
      {visuals[variant] || visuals.massage}
    </svg>
  );
}
